import m from "./index31.js";
import { resolveComponent as d, openBlock as t, createElementBlock as s, createVNode as u, normalizeClass as n, withCtx as p, createElementVNode as i, toDisplayString as r } from "vue";
import "./index32.js";
import c from "../../../../_virtual/index.js";
const y = { class: "menu-category" }, C = ["href"];
function g(e, o, f, h, v, k) {
  const l = d("DropdownMenu");
  return t(), s("div", y, [
    u(l, {
      menuItems: e.dropdownMenuItems,
      type: e.menuType,
      hasArrowIcon: e.hasArrowIcon,
      class: n([e.hasArrowIcon ? "" : " disabled-link"])
    }, {
      title: p(() => [
        i("div", {
          class: n(["category-nav-link", e.name]),
          onClick: o[1] || (o[1] = (...a) => e.handleMenuCategoryClick && e.handleMenuCategoryClick(...a))
        }, [
          e.shouldRedirect ? (t(), s("a", {
            key: 0,
            class: n(["menu-text category-name-no-touch", e.menuCategoryTextAdditionalClasses]),
            href: e.url,
            onClick: o[0] || (o[0] = (...a) => e.navigationEventBus.navigateToHref && e.navigationEventBus.navigateToHref(...a))
          }, r(e.name), 11, C)) : (t(), s("span", {
            key: 1,
            class: n(["menu-text category-name-no-touch", e.menuCategoryTextAdditionalClasses])
          }, r(e.name), 3)),
          i("span", {
            class: n(["menu-text category-name-touch", e.menuCategoryTextAdditionalClasses])
          }, r(e.name), 3)
        ], 2)
      ]),
      _: 1
    }, 8, ["menuItems", "type", "hasArrowIcon", "class"])
  ]);
}
const T = /* @__PURE__ */ c(m, [["render", g], ["__scopeId", "data-v-eec2280d"]]);
export {
  T as default
};
//# sourceMappingURL=index14.js.map
